export default __webpack_public_path__ + "static/media/slider3.0999d40a.jpg";